var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 454 153",
    width: 454,
    height: 153,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #00539e } \n\t\t.s2 { fill: #009370 } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "watermark_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "watermark",
    style: {
      opacity: 0.6
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m190.8 289.2l-5.6 12.8h-2.9l-5.6-12.8h3.2l3.9 9.1 4-9.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m200.5 297.7h-7.5c0.3 1.3 1.4 2 2.9 2 1 0 1.8-0.3 2.4-0.9l1.6 1.6c-1 1.1-2.3 1.6-4.1 1.6-3.4 0-5.6-2.1-5.6-5.1 0-2.9 2.2-5 5.2-5 2.9 0 5.2 1.9 5.2 5.1 0 0.2-0.1 0.5-0.1 0.7zm-7.5-1.6h4.9c-0.2-1.3-1.2-2.1-2.5-2.1-1.3 0-2.2 0.8-2.4 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m201.7 296.9c0-2.9 2.3-5 5.5-5 2.1 0 3.7 0.9 4.5 2.5l-2.3 1.2c-0.5-1-1.3-1.4-2.2-1.4-1.4 0-2.6 1-2.6 2.7 0 1.8 1.2 2.8 2.6 2.8 0.9 0 1.7-0.4 2.2-1.4l2.3 1.2c-0.8 1.6-2.4 2.5-4.5 2.5-3.2 0-5.5-2.1-5.5-5.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m219.8 301.4c-0.6 0.4-1.4 0.6-2.3 0.6-2.3 0-3.7-1.2-3.7-3.5v-4.1h-1.5v-2.2h1.5v-2.4h2.9v2.4h2.4v2.2h-2.4v4c0 0.9 0.4 1.3 1.2 1.3 0.4 0 0.8-0.1 1.2-0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m239.5 292v2.6c-0.3 0-0.4 0-0.7 0-1.5 0-2.6 0.9-2.6 2.8v4.6h-2.9v-9.9h2.8v1.3c0.7-0.9 1.9-1.4 3.4-1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m240.3 300.5l1-2.2c1.1 0.8 2.7 1.3 4.2 1.3 1.8 0 2.5-0.6 2.5-1.3 0-2.4-7.4-0.8-7.4-5.6 0-2.2 1.7-4 5.4-4 1.6 0 3.2 0.4 4.4 1.2l-0.9 2.2c-1.2-0.7-2.4-1-3.6-1-1.7 0-2.4 0.7-2.4 1.5 0 2.4 7.5 0.7 7.5 5.4 0 2.2-1.8 4-5.5 4-2 0-4.1-0.6-5.2-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m262.4 297.7h-7.4c0.2 1.3 1.3 2 2.8 2 1 0 1.8-0.3 2.5-0.9l1.5 1.6c-0.9 1.1-2.3 1.6-4.1 1.6-3.4 0-5.6-2.1-5.6-5.1 0-2.9 2.2-5 5.2-5 2.9 0 5.2 1.9 5.2 5.1 0 0.2-0.1 0.5-0.1 0.7zm-7.5-1.6h4.9c-0.2-1.3-1.2-2.1-2.4-2.1-1.3 0-2.3 0.8-2.5 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m274 297.7h-7.5c0.3 1.3 1.4 2 2.9 2 1 0 1.8-0.3 2.4-0.9l1.6 1.6c-1 1.1-2.3 1.6-4.1 1.6-3.4 0-5.6-2.1-5.6-5.1 0-2.9 2.2-5 5.2-5 2.9 0 5.2 1.9 5.2 5.1 0 0.2-0.1 0.5-0.1 0.7zm-7.5-1.6h4.9c-0.2-1.3-1.2-2.1-2.5-2.1-1.3 0-2.2 0.8-2.4 2.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m280.2 298.1l-1.4 1.4v2.5h-2.8v-13.6h2.8v7.7l4.2-4h3.4l-4.1 4.2 4.5 5.7h-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m233.6 303.4l-2.9-2.9q-0.6 0.8-1.5 1.3-0.1 0.1-0.3 0.2l3.1 3c0.4 0.5 1.1 0.5 1.6 0 0.5-0.4 0.5-1.2 0-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m231.6 296.6c0 3-2.4 5.4-5.4 5.4-3 0-5.4-2.4-5.4-5.4 0-2.9 2.2-5.2 5-5.4q0.1-0.2 0.1-0.3 0-0.3-0.2-0.5c0.2 0.1 0.4 0.3 0.4 0.5q0 0.2-0.1 0.3 0.1 0 0.2 0c0.2-0.3 0.5-0.5 0.9-0.5q0.5 0 0.8 0.3-0.1 0-0.1 0-0.5 0-0.8 0.2c2.6 0.4 4.6 2.7 4.6 5.4zm-7.7-3.7q0.4-0.1 0.8-0.1 0.7 0 1.3 0.3 0.1 0.1 0.2 0.2 0.1-0.1 0.2-0.2 0.6-0.3 1.2-0.3c0.7 0 1.2 0.2 1.7 0.6-0.5-0.5-1.1-0.8-1.8-0.8q-0.7 0-1.3 0.4-0.6-0.3-1.2-0.3-0.6 0-1.1 0.2zm5.9 2.4c0-1.2-1-2.2-2.2-2.2-0.5 0-1 0.2-1.4 0.6-0.4-0.4-0.9-0.6-1.5-0.6-1.2 0-2.2 1-2.2 2.2 0 0.7 0.5 1.4 1.1 1.8q-0.2 0.5-0.2 1c0 1.5 1.2 2.8 2.8 2.8 1.5 0 2.8-1.3 2.8-2.8q-0.1-0.5-0.2-1c0.6-0.4 1-1.1 1-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m228.7 295.1c0 0.5-0.4 0.9-0.9 0.9-0.5 0-0.9-0.4-0.9-0.9 0-0.5 0.4-0.9 0.9-0.9q0.1 0 0.3 0-0.1 0.1-0.1 0.2c0 0.3 0.2 0.5 0.5 0.5q0.1 0 0.1 0 0.1 0.1 0.1 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m225.3 295.1c0 0.3-0.4 0.6-0.7 0.6-0.4 0-0.7-0.3-0.7-0.6 0-0.4 0.3-0.7 0.7-0.7q0.1 0 0.2 0 0 0.1 0 0.2c0 0.2 0.1 0.3 0.3 0.3q0.1 0 0.1 0 0.1 0.1 0.1 0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m219.9 295.8h0.6v0.6h-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m231.8 295.8h0.6v0.6h-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m232.2 296.1h-0.1c0-3.3-2.7-5.9-5.9-5.9-3.3 0-5.9 2.6-5.9 5.9h-0.2c0-1.6 0.7-3.1 1.8-4.3 1.2-1.1 2.7-1.7 4.3-1.7 1.6 0 3.1 0.6 4.2 1.7 1.2 1.2 1.8 2.7 1.8 4.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m225.9 289.8h0.6v0.6h-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m221.9 290.1h8.5v0.1h-8.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m222.2 290.1c0 0.2-0.1 0.2-0.2 0.2-0.1 0-0.2 0-0.2-0.2 0-0.1 0.1-0.1 0.2-0.1 0.1 0 0.2 0 0.2 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m230.6 290.1c0 0.2-0.1 0.2-0.2 0.2-0.1 0-0.2 0-0.2-0.2 0-0.1 0.1-0.1 0.2-0.1 0.1 0 0.2 0 0.2 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m291.4 301.4c0 1.6-2.4 1.6-2.4 0 0-1.5 2.4-1.5 2.4 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m138.7 294.5l1.8 6.1 1.9-6.1h2.2l-2.8 8.2h-2.4l-0.8-2.4-0.7-2.7-0.8 2.7-0.8 2.4h-2.3l-2.9-8.2h2.3l1.8 6.1 1.8-6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m153.7 294.5l1.8 6.1 1.8-6.1h2.3l-2.9 8.2h-2.3l-0.8-2.4-0.8-2.7-0.7 2.7-0.8 2.4h-2.3l-2.9-8.2h2.2l1.9 6.1 1.8-6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m168.7 294.5l1.8 6.1 1.8-6.1h2.2l-2.8 8.2h-2.3l-0.9-2.4-0.7-2.7-0.7 2.7-0.8 2.4h-2.4l-2.8-8.2h2.2l1.9 6.1 1.7-6.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m177.9 301.5c0 1.6-2.4 1.6-2.4 0 0-1.5 2.4-1.5 2.4 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m299.7 301.4c-0.9 0.9-1.9 1.3-3.1 1.3-2.4 0-4.3-1.4-4.3-4.3 0-2.9 1.9-4.3 4.3-4.3 1.1 0 2 0.4 2.9 1.2l-1.3 1.4c-0.4-0.5-1-0.7-1.6-0.7-1.3 0-2.3 1-2.3 2.4 0 1.5 1 2.4 2.3 2.4 0.6 0 1.3-0.2 1.8-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m308.8 298.5c0 2.3-1.6 4.2-4.2 4.2-2.6 0-4.2-1.9-4.2-4.2 0-2.3 1.6-4.2 4.2-4.2 2.5 0 4.2 1.9 4.2 4.2zm-6.4 0c0 1.2 0.7 2.4 2.2 2.4 1.4 0 2.2-1.2 2.2-2.4 0-1.2-0.9-2.4-2.2-2.4-1.5 0-2.2 1.2-2.2 2.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m315.6 302.7v-4.3c0-1.1-0.6-2.1-1.7-2.1-1.1 0-1.7 1-1.7 2.1v4.3h-2v-8.1h1.8l0.2 1c0.4-0.9 1.4-1.1 2.1-1.1 1 0 2 0.3 2.4 1.5 0.7-1.2 1.7-1.5 2.7-1.5 2.3 0 3.5 1.4 3.5 3.8v4.4h-2v-4.4c0-1-0.5-1.9-1.6-1.9-1.1 0-1.7 0.9-1.7 2v4.3c0 0-2 0-2 0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.6
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m323 270.4c0 1-0.7 1.8-1.7 2.1-0.3 0-0.5 0-0.8 0-0.5 0-0.5 0-0.5 0.5q0 3.4 0 6.8 0 1.7-1.8 1.7-12 0-24 0-1.8 0.1-1.8-1.7 0-3.4 0-6.7c0-0.6 0-0.6-0.6-0.6-1.6 0-2.4-0.8-2.4-2.4 0-3.5 0-7 0-10.5-0.1-1.5 1-2.6 2.4-2.4 0.6 0 0.6 0 0.6-0.6q0-5.6 0-11.2c0-0.9 0.3-1.5 1.1-1.8q9.4 0 18.7 0c0.1 0.2 0.3 0.3 0.4 0.4q3.5 4 7 8 0.4 0.4 0.4 1 0 1.6 0 3.3c0 1-0.1 0.8 0.8 0.9 1.2 0 2.2 0.9 2.2 2.1q0 5.5 0 11.1zm-29-24.7q0 5.5 0 10.9c0 0.6 0 0.6 0.5 0.6q5.9 0 11.7 0 5.8 0 11.7 0c0.4 0 0.5-0.1 0.5-0.5q0-1.4 0-2.7c0-0.5 0-0.5-0.5-0.5q-2.9 0-5.7 0c-0.8 0-1.1-0.2-1.1-1q0-3.4 0-6.8c0-0.5 0-0.5-0.6-0.5q-8 0-16 0c-0.5 0-0.5 0-0.5 0.5zm24.4 33.3q0-3 0-6c0-0.5 0-0.5-0.5-0.5q-11.7 0-23.4 0c-0.5 0-0.5 0-0.5 0.5q0 3 0 6c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.8 0 11.6 0c0.6 0 0.6 0 0.6-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m304.4 245.1h1.8v1h-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m302.7 246.1h1.7v1.1h-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m304.4 247.2h1.8v1h-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m302.7 248.2h1.7v1.1h-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m304.4 249.3h1.8v1h-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m302.7 250.3h1.7v1.1h-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m304.4 251.4h1.8v1h-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m302.7 252.4h1.7v1.1h-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m304.4 253.5h1.8v1h-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m302.7 254.5h1.7v1.1h-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m304.4 255.6h1.8v1h-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m302.7 256.6h1.7v1.1h-1.7z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m164.6 270.4c0 1-0.7 1.8-1.7 2.1-0.2 0-0.5 0-0.8 0-0.5 0-0.5 0-0.5 0.5q0 3.4 0 6.8 0 1.7-1.7 1.7-12.1 0-24.1 0-1.8 0.1-1.8-1.7 0-3.4 0-6.7c0-0.6 0-0.6-0.5-0.6-1.6 0-2.5-0.8-2.5-2.4 0-3.5 0-7 0-10.5 0-1.5 1-2.6 2.5-2.4 0.5 0 0.5 0 0.5-0.6q0.1-5.6 0-11.2c0-0.9 0.4-1.5 1.2-1.8q9.3 0 18.6 0c0.2 0.2 0.3 0.3 0.4 0.4q3.5 4 7.1 8 0.3 0.4 0.3 1 0 1.6 0 3.3c0 1-0.1 0.8 0.8 0.9 1.3 0 2.2 0.9 2.2 2.1q0.1 5.5 0 11.1zm-29-24.7q0 5.5 0 10.9c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.9 0 11.7 0c0.5 0 0.5-0.1 0.5-0.5q0-1.4 0-2.7c0-0.5 0-0.5-0.5-0.5q-2.8 0-5.7 0c-0.8 0-1-0.2-1-1q0-3.4 0-6.8c0-0.5-0.1-0.5-0.6-0.5q-8 0-16 0c-0.6 0-0.6 0-0.6 0.5zm24.4 33.3q0-3 0-6c0-0.5 0-0.5-0.5-0.5q-11.7 0-23.4 0c-0.4 0-0.5 0-0.5 0.5q0 3 0 6c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.8 0 11.7 0c0.5 0 0.5 0 0.5-0.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m136.8 268.7v-7.9h2.8q0.5 0 1 0.2 0.5 0.1 0.9 0.5 0.3 0.3 0.5 0.8 0.2 0.4 0.2 1 0 0.5-0.2 1-0.2 0.4-0.5 0.8-0.4 0.3-0.9 0.5-0.5 0.2-1 0.2h-1.3v2.9c0 0-1.5 0-1.5 0zm2.8-4.3q0.6 0 0.9-0.4 0.3-0.3 0.3-0.7 0-0.2-0.1-0.4-0.1-0.2-0.2-0.4-0.2-0.1-0.4-0.2-0.2-0.1-0.5-0.1h-1.3v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m143.3 260.8h1.7l3.2 5.3h0.1l-0.1-1.6v-3.7h1.5v7.9h-1.6l-3.3-5.6h-0.1l0.1 1.5v4.1h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m154.9 264.3h3.9q0 0.2 0 0.4 0.1 0.1 0.1 0.3 0 0.8-0.3 1.5-0.2 0.6-0.7 1.2-0.5 0.5-1.3 0.8-0.7 0.3-1.6 0.3-0.9 0-1.7-0.3-0.7-0.3-1.3-0.8-0.6-0.6-0.9-1.3-0.3-0.8-0.3-1.7 0-0.9 0.3-1.6 0.3-0.8 0.9-1.3 0.6-0.6 1.3-0.9 0.8-0.3 1.7-0.3 0.9 0 1.7 0.3 0.7 0.4 1.3 0.9l-1.1 1q-0.3-0.4-0.8-0.6-0.5-0.2-1.2-0.2-0.5 0-1 0.2-0.5 0.2-0.8 0.5-0.4 0.4-0.6 0.9-0.2 0.5-0.2 1.1 0 0.6 0.2 1.1 0.2 0.5 0.6 0.9 0.3 0.3 0.8 0.5 0.5 0.2 1.1 0.2 0.6 0 1-0.1 0.5-0.2 0.8-0.5 0.2-0.2 0.4-0.5 0.1-0.3 0.2-0.7h-2.5c0 0 0-1.3 0-1.3z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m201 270.4c0 1-0.7 1.8-1.7 2.1-0.2 0-0.5 0-0.8 0-0.5 0-0.5 0-0.5 0.5q0 3.4 0 6.8 0 1.7-1.8 1.7-12 0-24 0-1.8 0.1-1.8-1.7 0-3.4 0-6.7c0-0.6 0-0.6-0.6-0.6-1.5 0-2.4-0.8-2.4-2.4 0-3.5 0-7 0-10.5 0-1.5 1-2.6 2.5-2.4 0.5 0 0.5 0 0.5-0.6q0-5.6 0-11.2c0-0.9 0.4-1.5 1.2-1.8q9.3 0 18.6 0c0.1 0.2 0.3 0.3 0.4 0.4q3.5 4 7 8 0.4 0.4 0.4 1 0 1.6 0 3.3c0 1-0.1 0.8 0.8 0.9 1.3 0 2.2 0.9 2.2 2.1q0 5.5 0 11.1zm-29-24.7q0 5.5 0 10.9c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.9 0 11.7 0c0.5 0 0.5-0.1 0.5-0.5q0-1.4 0-2.7c0-0.5 0-0.5-0.5-0.5q-2.8 0-5.7 0c-0.8 0-1.1-0.2-1.1-1q0-3.4 0-6.8c0-0.5 0-0.5-0.5-0.5q-8 0-16 0c-0.6 0-0.6 0-0.6 0.5zm24.4 33.3q0-3 0-6c0-0.5 0-0.5-0.5-0.5q-11.7 0-23.4 0c-0.5 0-0.5 0-0.5 0.5q0 3 0 6c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.8 0 11.7 0c0.5 0 0.5 0 0.5-0.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m182.1 260.8h1.7l3 7.9h-1.7l-0.6-1.9h-3.1l-0.6 1.9h-1.7zm1.9 4.6l-0.7-2-0.3-0.9h-0.1l-0.2 0.9-0.7 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m188.3 262.5q-0.2 0-0.3 0-0.2-0.1-0.3-0.2-0.2-0.2-0.2-0.3-0.1-0.2-0.1-0.4 0-0.2 0.1-0.4 0-0.1 0.2-0.2 0.1-0.2 0.3-0.2 0.1-0.1 0.3-0.1 0.4 0 0.7 0.3 0.3 0.2 0.3 0.6 0 0.4-0.3 0.7-0.3 0.2-0.7 0.2zm-0.7 6.2v-5.4h1.5v5.4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m238 270.4c0 1-0.7 1.8-1.7 2.1-0.2 0-0.5 0-0.8 0-0.5 0-0.5 0-0.5 0.5q0 3.4 0 6.8 0 1.7-1.7 1.7-12.1 0-24.1 0-1.8 0.1-1.7-1.7 0-3.4 0-6.7c0-0.6 0-0.6-0.6-0.6-1.6 0-2.5-0.8-2.5-2.4 0-3.5 0.1-7 0-10.5 0-1.5 1-2.6 2.5-2.4 0.6 0 0.6 0 0.6-0.6q0-5.6-0.1-11.2c0-0.9 0.4-1.5 1.2-1.8q9.3 0 18.6 0c0.2 0.2 0.3 0.3 0.4 0.4q3.6 4 7.1 8 0.3 0.4 0.3 1 0 1.6 0 3.3c0 1-0.1 0.8 0.9 0.9 1.2 0 2.1 0.9 2.1 2.1q0.1 5.5 0 11.1zm-29-24.7q0 5.5 0 10.9c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.9 0 11.7 0c0.5 0 0.5-0.1 0.5-0.5q0-1.4 0-2.7c0-0.5 0-0.5-0.5-0.5q-2.8 0-5.7 0c-0.8 0-1-0.2-1-1q0-3.4 0-6.8c0-0.5 0-0.5-0.6-0.5q-8 0-16 0c-0.6 0-0.6 0-0.6 0.5zm24.4 33.3q0-3 0-6c0-0.5 0-0.5-0.5-0.5q-11.7 0-23.4 0c-0.4 0-0.5 0-0.5 0.5q0 3 0 6c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.9 0 11.7 0c0.5 0 0.5 0 0.5-0.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m213.4 268.8q-0.5 0-1-0.1-0.5-0.1-0.9-0.4-0.3-0.3-0.6-0.7-0.3-0.4-0.5-1l1.4-0.5q0.2 0.6 0.6 0.9 0.3 0.4 1 0.4 0.2 0 0.4 0 0.2-0.1 0.4-0.2 0.2-0.1 0.3-0.3 0.1-0.2 0.1-0.4 0-0.2-0.1-0.4-0.1-0.2-0.3-0.3-0.1-0.2-0.4-0.3-0.3-0.2-0.8-0.3l-0.4-0.2q-0.4-0.1-0.7-0.3-0.3-0.2-0.6-0.5-0.2-0.2-0.4-0.6-0.2-0.3-0.2-0.8 0-0.4 0.2-0.9 0.2-0.4 0.5-0.7 0.3-0.3 0.8-0.4 0.5-0.2 1.1-0.2 0.6 0 1 0.2 0.4 0.1 0.7 0.4 0.3 0.2 0.5 0.5 0.2 0.3 0.3 0.6l-1.3 0.5q-0.1-0.3-0.4-0.6-0.3-0.2-0.8-0.2-0.5 0-0.8 0.2-0.3 0.2-0.3 0.6 0 0.3 0.3 0.6 0.3 0.2 0.9 0.5l0.5 0.1q0.5 0.2 0.9 0.4 0.4 0.2 0.7 0.5 0.3 0.3 0.4 0.7 0.2 0.4 0.2 0.9 0 0.6-0.3 1-0.2 0.5-0.6 0.8-0.4 0.3-0.9 0.4-0.5 0.1-0.9 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m216.5 260.8h1.6l1.7 4.7 0.2 1h0.1l0.3-1 1.7-4.7h1.7l-2.9 7.9h-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m228.1 264.3h3.9q0 0.2 0 0.4 0 0.1 0 0.3 0 0.8-0.2 1.5-0.2 0.6-0.7 1.2-0.5 0.5-1.3 0.8-0.7 0.3-1.7 0.3-0.8 0-1.6-0.3-0.8-0.3-1.3-0.8-0.6-0.6-0.9-1.3-0.3-0.8-0.3-1.7 0-0.9 0.3-1.6 0.3-0.8 0.9-1.3 0.5-0.6 1.3-0.9 0.8-0.3 1.6-0.3 1 0 1.7 0.3 0.8 0.4 1.3 0.9l-1 1q-0.4-0.4-0.8-0.6-0.5-0.2-1.2-0.2-0.5 0-1 0.2-0.5 0.2-0.9 0.5-0.3 0.4-0.5 0.9-0.3 0.5-0.3 1.1 0 0.6 0.3 1.1 0.2 0.5 0.5 0.9 0.4 0.3 0.9 0.5 0.5 0.2 1 0.2 0.7 0 1.1-0.1 0.4-0.2 0.7-0.5 0.3-0.2 0.4-0.5 0.2-0.3 0.3-0.7h-2.5c0 0 0-1.3 0-1.3z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m274.3 270.4c0 1-0.7 1.8-1.7 2.1-0.3 0-0.5 0-0.8 0-0.5 0-0.5 0-0.5 0.5q0 3.4 0 6.8 0 1.7-1.8 1.7-12 0-24 0-1.8 0.1-1.8-1.7 0-3.4 0-6.7c0-0.6 0-0.6-0.6-0.6-1.6 0-2.4-0.8-2.4-2.4 0-3.5 0-7 0-10.5-0.1-1.5 1-2.6 2.5-2.4 0.5 0 0.5 0 0.5-0.6q0-5.6 0-11.2c0-0.9 0.3-1.5 1.1-1.8q9.4 0 18.7 0c0.1 0.2 0.3 0.3 0.4 0.4q3.5 4 7 8 0.4 0.4 0.4 1 0 1.6 0 3.3c0 1-0.1 0.8 0.8 0.9 1.2 0 2.2 0.9 2.2 2.1q0 5.5 0 11.1zm-29-24.7q0 5.5 0 10.9c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.8 0 11.7 0c0.5 0 0.5-0.1 0.5-0.5q0-1.4 0-2.7c0-0.5 0-0.5-0.5-0.5q-2.9 0-5.7 0c-0.8 0-1.1-0.2-1.1-1q0-3.4 0-6.8c0-0.5 0-0.5-0.5-0.5q-8 0-16 0c-0.6 0-0.6 0-0.6 0.5zm24.4 33.3q0-3 0-6c0-0.5 0-0.5-0.5-0.5q-11.7 0-23.4 0c-0.5 0-0.5 0-0.5 0.5q0 3 0 6c0 0.6 0 0.6 0.6 0.6q5.8 0 11.6 0 5.8 0 11.6 0c0.6 0 0.6 0 0.6-0.6z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m250 262.2v1.8h3.1v1.4h-3.1v1.9h3.5v1.4h-5v-7.9h5v1.4c0 0-3.5 0-3.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m254.9 268.7v-7.9h2.7q0.6 0 1.1 0.2 0.5 0.1 0.8 0.5 0.4 0.3 0.6 0.8 0.2 0.4 0.2 1 0 0.5-0.2 1-0.2 0.4-0.6 0.8-0.3 0.3-0.8 0.5-0.5 0.2-1.1 0.2h-1.3v2.9c0 0-1.4 0-1.4 0zm2.8-4.3q0.5 0 0.8-0.4 0.3-0.3 0.3-0.7 0-0.2 0-0.4-0.1-0.2-0.3-0.4-0.1-0.1-0.3-0.2-0.3-0.1-0.5-0.1h-1.4v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m263.8 268.8q-0.5 0-1-0.1-0.4-0.1-0.8-0.4-0.4-0.3-0.7-0.7-0.3-0.4-0.4-1l1.4-0.5q0.1 0.6 0.5 0.9 0.4 0.4 1 0.4 0.2 0 0.5 0 0.2-0.1 0.3-0.2 0.2-0.1 0.3-0.3 0.1-0.2 0.1-0.4 0-0.2-0.1-0.4 0-0.2-0.2-0.3-0.2-0.2-0.5-0.3-0.3-0.2-0.7-0.3l-0.5-0.2q-0.3-0.1-0.7-0.3-0.3-0.2-0.5-0.5-0.3-0.2-0.5-0.6-0.1-0.3-0.1-0.8 0-0.4 0.1-0.9 0.2-0.4 0.6-0.7 0.3-0.3 0.8-0.4 0.4-0.2 1-0.2 0.6 0 1 0.2 0.5 0.1 0.8 0.4 0.3 0.2 0.5 0.5 0.1 0.3 0.2 0.6l-1.3 0.5q-0.1-0.3-0.4-0.6-0.3-0.2-0.8-0.2-0.5 0-0.8 0.2-0.3 0.2-0.3 0.6 0 0.3 0.3 0.6 0.3 0.2 1 0.5l0.5 0.1q0.5 0.2 0.9 0.4 0.3 0.2 0.6 0.5 0.3 0.3 0.5 0.7 0.1 0.4 0.1 0.9 0 0.6-0.2 1-0.3 0.5-0.7 0.8-0.4 0.3-0.9 0.4-0.4 0.1-0.9 0.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m298.4 267.2l4-5h-3.8v-1.4h5.5v1.5l-3.9 5h4v1.4h-5.8c0 0 0-1.5 0-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m305.4 260.8h1.5v7.9h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m308.5 268.7v-7.9h2.8q0.5 0 1 0.2 0.5 0.1 0.9 0.5 0.3 0.3 0.5 0.8 0.3 0.4 0.3 1 0 0.5-0.3 1-0.2 0.4-0.5 0.8-0.4 0.3-0.9 0.5-0.5 0.2-1 0.2h-1.3v2.9c0 0-1.5 0-1.5 0zm2.8-4.3q0.6 0 0.9-0.4 0.3-0.3 0.3-0.7 0-0.2-0.1-0.4-0.1-0.2-0.2-0.4-0.2-0.1-0.4-0.2-0.2-0.1-0.5-0.1h-1.3v2.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.6
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m277.1 261.3h9.1v2.2h-9.1zm0 3.9h9.1v2.2h-9.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    style: {
      opacity: 0.6
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m133.8 306.9h1.6c1.2 0 2.1 0.8 2.1 2 0 1.1-0.9 1.9-2.1 1.9h-1.6zm1.5 3.6c1.1 0 1.8-0.7 1.8-1.6 0-0.9-0.7-1.6-1.8-1.6h-1.1v3.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m142.1 308.9c0-1.2 0.9-2.1 2.1-2.1 1.2 0 2.1 0.9 2.1 2.1 0 1.1-0.9 2-2.1 2-1.2 0-2.1-0.9-2.1-2zm3.8 0c0-1-0.7-1.7-1.7-1.7-0.9 0-1.6 0.7-1.6 1.7 0 0.9 0.7 1.6 1.6 1.6 1 0 1.7-0.7 1.7-1.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m156.6 306.9l-1.3 3.9h-0.5l-1.1-3.3-1.2 3.3h-0.4l-1.4-3.9h0.5l1.1 3.4 1.2-3.4h0.4l1.1 3.4 1.2-3.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m164.7 306.9v3.9h-0.3l-2.5-3.2v3.2h-0.5v-3.9h0.4l2.5 3.2v-3.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m170.1 306.9h0.4v3.6h2.2v0.3h-2.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m177.1 308.9c0-1.2 0.8-2.1 2-2.1 1.2 0 2.1 0.9 2.1 2.1 0 1.1-0.9 2-2.1 2-1.2 0-2-0.9-2-2zm3.7 0c0-1-0.7-1.7-1.7-1.7-0.9 0-1.6 0.7-1.6 1.7 0 0.9 0.7 1.6 1.6 1.6 1 0 1.7-0.7 1.7-1.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m188.6 309.8h-2.2l-0.4 1h-0.5l1.8-3.9h0.4l1.8 3.9h-0.4zm-0.1-0.3l-1-2.1-0.9 2.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m194.3 306.9h1.6c1.2 0 2.1 0.8 2.1 2 0 1.1-0.9 1.9-2.1 1.9h-1.6zm1.6 3.6c1 0 1.7-0.7 1.7-1.6 0-0.9-0.7-1.6-1.7-1.6h-1.2v3.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m211 309.8h-2.2l-0.4 1h-0.5l1.8-3.9h0.5l1.8 3.9h-0.5zm-0.1-0.3l-1-2.1-0.9 2.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m216.7 306.9h0.4v3.6h2.2v0.3h-2.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m224.1 306.9h0.4v3.6h2.2v0.3h-2.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m237.4 307.2v1.6h2.1v0.4h-2.1v1.6h-0.4v-3.9h2.7v0.3c0 0-2.3 0-2.3 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m244.7 306.9h0.4v3.9h-0.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m250.5 306.9h0.4v3.6h2.2v0.3h-2.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m260.6 310.5v0.3h-2.7v-3.9h2.7v0.3h-2.3v1.4h2v0.4h-2v1.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m271.7 307.2v1.6h2v0.4h-2v1.6h-0.4v-3.9h2.7v0.3c0 0-2.3 0-2.3 0z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m278.5 308.9c0-1.2 0.9-2.1 2.1-2.1 1.2 0 2 0.9 2 2.1 0 1.1-0.8 2-2 2-1.2 0-2.1-0.9-2.1-2zm3.7 0c0-1-0.7-1.7-1.6-1.7-1 0-1.7 0.7-1.7 1.7 0 0.9 0.7 1.6 1.7 1.6 0.9 0 1.6-0.7 1.6-1.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m290.4 310.8l-1-1.2q-0.1 0-0.3 0h-1v1.2h-0.4v-3.9h1.4c1 0 1.6 0.5 1.6 1.3 0 0.7-0.3 1.1-0.9 1.3l1 1.3c0 0-0.4 0-0.4 0zm-0.1-2.6c0-0.6-0.4-1-1.2-1h-1v2h1c0.8 0 1.2-0.3 1.2-1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m299.9 306.9v3.9h-0.4v-3.1l-1.5 2.6h-0.2l-1.6-2.6v3.1h-0.4v-3.9h0.4l1.7 2.9 1.7-2.9c0 0 0.3 0 0.3 0z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m307.7 309.8h-2.2l-0.4 1h-0.5l1.8-3.9h0.5l1.8 3.9h-0.5zm-0.1-0.3l-1-2.1-0.9 2.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m314 307.2h-1.4v-0.3h3.2v0.3h-1.4v3.6h-0.4c0 0 0-3.6 0-3.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m320.1 310.3l0.1-0.3c0.3 0.3 0.8 0.5 1.3 0.5 0.8 0 1.1-0.3 1.1-0.7 0-1.1-2.4-0.4-2.4-1.9 0-0.6 0.4-1.1 1.4-1.1 0.5 0 0.9 0.2 1.2 0.4l-0.1 0.3c-0.3-0.2-0.7-0.3-1.1-0.3-0.7 0-1 0.3-1 0.7 0 1.1 2.4 0.4 2.4 1.9 0 0.6-0.5 1.1-1.5 1.1-0.6 0-1.1-0.3-1.4-0.6z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m38.7 108.1l24.3 41.8h-13.5c-0.5 0-0.7-0.2-1-0.6l-19.2-33.1-9 15.4h14.2c0.5 0 0.7 0.3 0.5 0.7-1.7 3.5-6.5 4.8-11.1 4.8h-6.8l-7.4 12.8h-7.7l23-39.5c0.6-1.1 0-1.8-1.9-1.8v-1.3h14.1c0.7 0 1.2 0.3 1.5 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m238.4 108.1l24.3 41.8h-13.5c-0.5 0-0.8-0.2-1-0.6l-19.3-33.1-9 15.4h14.3c0.5 0 0.6 0.3 0.4 0.7-1.7 3.5-6.5 4.8-11.1 4.8h-6.7l-7.5 12.8h-7.6l22.9-39.5c0.6-1.1 0.1-1.8-1.8-1.8v-1.4h14.1c0.7 0 1.2 0.4 1.5 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m427.7 108.1l24.3 41.8h-13.5c-0.5 0-0.8-0.2-1-0.6l-19.3-33.1-9 15.4h14.3c0.5 0 0.6 0.3 0.4 0.7-1.7 3.5-6.5 4.8-11.1 4.8h-6.7l-7.5 12.8h-7.6l22.9-39.5c0.6-1.1 0.1-1.8-1.9-1.8v-1.4h14.2c0.7 0 1.2 0.4 1.5 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m113.6 127.8c0 14.1-7.4 19.2-20.6 17.8 1.9 4.2 5.1 5.2 11.2 5.2 10.7 0 22.2-6.6 22.2-23 0-14-12.3-20.5-30.1-20.5h-21.2v1.4c0.9 0 1.7 0.1 2.3 0.5 0.5 0.4 0.6 1.2 0.6 2.2v35c0 0.6 0.3 1.3 0.8 1.6 3.3 1.8 6.7 2.5 10.1 2.8 1 0.1 1.3-0.2 1.3-1v-34.2c0-2.5 1.5-4.3 4.4-4.4 11.2-0.1 19 4.3 19 16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m174.9 149.5q-0.2 0.4-0.7 0.4h-11.1l-23.7-40.6c-0.3-0.6-1.4-0.7-2.8-0.7v-1.3h14.9c0.7 0 1.2 0.2 1.5 0.8l21.8 37.5c1 0 0.9-1.6 0.4-2.8-1-2.3-1.4-4.2-0.3-6.1l17.1-29.4h7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m327.5 107.9v41.9c-0.9 0-2.4-0.1-3-0.5l-38.7-31.6c-0.3-0.3-0.9-0.3-0.9 0.2v32h-6.4q-0.9 0-0.9-1v-37.3c0-0.8-0.2-1.8-0.7-2.3-0.5-0.5-1.8-0.7-3.2-0.7v-1.4h17.1c0.7 0 2.2 0.4 2.6 0.9l26.3 21.5q0.4 0.3 0.4-0.1v-22.2h6.7c0.3 0 0.7 0.2 0.7 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m341 107.3h49.6c0.5 0 0.6 0.3 0.4 0.7-1.6 3.5-6.5 4.7-11 4.7h-8.9v37.2h-11.4q-1 0-1-1v-36.2h-17.7v-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m216.5 8.3c-0.3-0.7-1.5-1.1-3.3-1.1v-2.1h21.2c1.1 0 1.8 0.6 2.3 1.4l45.4 77.9h-20.3c-0.7 0-1.1-0.3-1.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m238.4 72.1c-5.1 12.8-17.5 21.7-32 21.7-19.1 0-34.5-15.4-34.5-34.4 0-19.1 15.4-34.5 34.5-34.5-3.3 5.7-25.6 44-26.3 45.1-3.1 5.4 8.4 4.3 18.9-13.9 0.3-0.4 14.6-25.3 17.2-29.8q1.8 0.6 3.5 1.3c-4.2 7.3-30.4 52.7-31.2 54-3.1 5.3 9.6 3.9 19.7-14 0.2-0.2 3.7-6.3 8-13.7 2-3.6 5.1-5.2 10.5-5.2 1 0 7 0 12.4-0.1 1.1 3.4 1.7 7 1.7 10.8q0 0.7 0 1.5c-10.7 0-21.7-0.3-25.8 8.5-2.1 4.3 2.9 2 7.6 1.8 4.4-0.2 11.4 0.1 15.8 0.9zm-23.4 5.5c0-2.5-2-4.5-4.5-4.5-2.5 0-4.5 2-4.5 4.5 0 2.5 2 4.5 4.5 4.5 2.5 0 4.5-2 4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m38.7 108.1l24.3 41.8h-13.5c-0.5 0-0.7-0.2-1-0.6l-19.2-33.1-9 15.4h14.2c0.5 0 0.7 0.3 0.5 0.7-1.7 3.5-6.5 4.8-11.1 4.8h-6.8l-7.4 12.8h-7.7l23-39.5c0.6-1.1 0-1.8-1.9-1.8v-1.3h14.1c0.7 0 1.2 0.3 1.5 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m238.4 108.1l24.3 41.8h-13.5c-0.5 0-0.8-0.2-1-0.6l-19.3-33.1-9 15.4h14.3c0.5 0 0.6 0.3 0.4 0.7-1.7 3.5-6.5 4.8-11.1 4.8h-6.7l-7.5 12.8h-7.6l22.9-39.5c0.6-1.1 0.1-1.8-1.8-1.8v-1.4h14.1c0.7 0 1.2 0.4 1.5 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m427.7 108.1l24.3 41.8h-13.5c-0.5 0-0.8-0.2-1-0.6l-19.3-33.1-9 15.4h14.3c0.5 0 0.6 0.3 0.4 0.7-1.7 3.5-6.5 4.8-11.1 4.8h-6.7l-7.5 12.8h-7.6l22.9-39.5c0.6-1.1 0.1-1.8-1.9-1.8v-1.4h14.2c0.7 0 1.2 0.4 1.5 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m113.6 127.8c0 14.1-7.4 19.2-20.6 17.8 1.9 4.2 5.1 5.2 11.2 5.2 10.7 0 22.2-6.6 22.2-23 0-14-12.3-20.5-30.1-20.5h-21.2v1.4c0.9 0 1.7 0.1 2.3 0.5 0.5 0.4 0.6 1.2 0.6 2.2v35c0 0.6 0.3 1.3 0.8 1.6 3.3 1.8 6.7 2.5 10.1 2.8 1 0.1 1.3-0.2 1.3-1v-34.2c0-2.5 1.5-4.3 4.4-4.4 11.2-0.1 19 4.3 19 16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m174.9 149.5q-0.2 0.4-0.7 0.4h-11.1l-23.7-40.6c-0.3-0.6-1.4-0.7-2.8-0.7v-1.3h14.9c0.7 0 1.2 0.2 1.5 0.8l21.8 37.5c1 0 0.9-1.6 0.4-2.8-1-2.3-1.4-4.2-0.3-6.1l17.1-29.4h7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m327.5 107.9v41.9c-0.9 0-2.4-0.1-3-0.5l-38.7-31.6c-0.3-0.3-0.9-0.3-0.9 0.2v32h-6.4q-0.9 0-0.9-1v-37.3c0-0.8-0.2-1.8-0.7-2.3-0.5-0.5-1.8-0.7-3.2-0.7v-1.4h17.1c0.7 0 2.2 0.4 2.6 0.9l26.3 21.5q0.4 0.3 0.4-0.1v-22.2h6.7c0.3 0 0.7 0.2 0.7 0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m341 107.3h49.6c0.5 0 0.6 0.3 0.4 0.7-1.6 3.5-6.5 4.7-11 4.7h-8.9v37.2h-11.4q-1 0-1-1v-36.2h-17.7v-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m216.5 8.3c-0.3-0.7-1.5-1.1-3.3-1.1v-2.1h21.2c1.1 0 1.8 0.6 2.3 1.4l45.4 77.9h-20.3c-0.7 0-1.1-0.3-1.5-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m238.4 72.1c-5.1 12.8-17.5 21.7-32 21.7-19.1 0-34.5-15.4-34.5-34.4 0-19.1 15.4-34.5 34.5-34.5-3.3 5.7-25.6 44-26.3 45.1-3.1 5.4 8.4 4.3 18.9-13.9 0.3-0.4 14.6-25.3 17.2-29.8q1.8 0.6 3.5 1.3c-4.2 7.3-30.4 52.7-31.2 54-3.1 5.3 9.6 3.9 19.7-14 0.2-0.2 3.7-6.3 8-13.7 2-3.6 5.1-5.2 10.5-5.2 1 0 7 0 12.4-0.1 1.1 3.4 1.7 7 1.7 10.8q0 0.7 0 1.5c-10.7 0-21.7-0.3-25.8 8.5-2.1 4.3 2.9 2 7.6 1.8 4.4-0.2 11.4 0.1 15.8 0.9zm-23.4 5.5c0-2.5-2-4.5-4.5-4.5-2.5 0-4.5 2-4.5 4.5 0 2.5 2 4.5 4.5 4.5 2.5 0 4.5-2 4.5-4.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.86a36a744a7f210aa4544977267c7b36.svg";
export { ForwardRef as ReactComponent };